import React, { useEffect, useState } from 'react';
import FullSearchBar from '../search-bars/full-search-bar';
import moment from 'moment';
import { MenuBar } from '../blog/menu-bar/menu';
import { AppStateContext, AppServicesContext, TranslationContext, AppState, InjectedContext } from '../../utils';
import { Router, RouteComponentProps } from 'react-router'
import { withTranslation as translate, WithTranslation } from 'react-i18next'



function BlogRootPageBase(props: RouteComponentProps<{}, {}> & React.PropsWithChildren<InjectedContext> & WithTranslation) {
    let searchProps = Object.assign({}, props, {
        user: props.state.userId,
        location: "",
        mobilityClass: "",
        startDate: undefined,
        endDate: undefined,
        state: props.state
    })
    const [oldLocation, setOldLocation] = useState<string>("")
    // TO DO
    // useEffect(() => {
    //     const path = props.location.pathname;
    //     if (!props.location.state?.noResetScroll &&
    //         !(oldLocation.indexOf("/content/post") !== -1 && path.indexOf("/content/post") !== -1)) {
    //         window.scrollTo(0, 0);
    //     }
    //     setOldLocation(path);
    // }, [props.location.pathname]);

    return <TranslationContext.Provider value={{ t: props.t }}>
        <AppServicesContext.Provider value={props as any}>
            <AppStateContext.Provider value={props.state}>
                <div className="blogPageWrapper">
                    {/*<div className="search-bar-wrapper">*/}
                    {/*    <FullSearchBar {...searchProps} />*/}
                    {/*</div>*/}
                    <div className='blog-menu-wrapper'>
                        <MenuBar />
                    </div>
                    <div>
                        {props.children}
                    </div>
                </div>
            </AppStateContext.Provider>
        </AppServicesContext.Provider>
    </TranslationContext.Provider>;
}

export const BlogRootPage = translate()(BlogRootPageBase)
export default BlogRootPage;
